<template>
    <div>
      <!-- <b-card> -->
        <b-row class="dashboard-ventas-trimestral">
          <b-col cols="3">
            <b-table hover
                responsive="sm" 
                class="registro"
                :busy="tableBusy"
                :items="ventasTrimestre1" 
                :fields="ventasTrimestreFields">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(valor)="data">
                {{ formattedData(data.item) }}
              </template>
            </b-table>
          </b-col>

          <b-col cols="3">
            <b-table hover
                responsive="sm" 
                class="registro"
                :busy="tableBusy"
                :items="ventasTrimestre2" 
                :fields="ventasTrimestreFields">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>              
              <template v-slot:cell(valor)="data">
                {{ formattedData(data.item) }}
              </template>
            </b-table>
          </b-col>

          <b-col cols="3">
            <b-table hover
                responsive="sm" 
                class="registro"
                :busy="tableBusy"
                :items="ventasTrimestre3" 
                :fields="ventasTrimestreFields">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>              
              <template v-slot:cell(valor)="data">
                {{ formattedData(data.item) }}
              </template>
            </b-table>
          </b-col>

          <b-col cols="3">
            <b-table hover
                responsive="sm" 
                class="registro"
                :busy="tableBusy"
                :items="ventasTrimestre4" 
                :fields="ventasTrimestreFields">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>              
              <template v-slot:cell(valor)="data">
                {{ formattedData(data.item) }}
              </template>
            </b-table>
          </b-col>
        </b-row>
        
        <b-row class="dashboard-venta-mensual">
          <b-col cols="6">
            <b-table hover
                responsive="sm" 
                :class="{ 'registro': true, 'reembolsos': ventaMensualBaseAnio <= 2023 ? true : false }"
                :busy="tableMensualBaseBusy"
                :items="ventaMensualBase" 
                :fields="ventaMensualBaseFields">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(periodo)="data">
                <template v-if="data.item.totales">
                  {{ data.item.titulo }}
                </template>
                <template v-if="!data.item.totales">
                  {{ data.item.periodo | periodo }}
                </template>
              </template>
              <template v-slot:cell(montoNeto)="data">
                {{ data.item.montoNeto | moneda }}
              </template>
              <template v-slot:cell(montoNetoSinReembolsos)="data">
                {{ data.item.montoNetoSinReembolsos | moneda }}
              </template>
              <template v-slot:cell(montoNetoReembolsos)="data">
                {{ data.item.montoNetoReembolsos | moneda }}
              </template>
              <template v-slot:cell(opciones)="data">
                <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                  <template slot="button-content">
                    <i class="fa fa-ellipsis-v"></i>
                  </template>
                  <b-dropdown-item @click.stop="exportarPeriodoBase(data.item)">
                    <i class="fa fa-file-excel-o"></i>Exportar Período</b-dropdown-item>
                  <b-dropdown-item 
                      v-if="consultarCompras"
                      @click.stop="exportarComprasPeriodoBase(data.item)">
                    <i class="fa fa-file-excel-o"></i>Exportar Compras</b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </b-col>

          <b-col cols="6">
            <b-table hover
                responsive="sm" 
                :class="{ 'registro': true, 'reembolsos': ventaMensualAnio <= 2023 ? true : false }"
                :busy="tableMensualBusy"
                :items="ventaMensual" 
                :fields="ventaMensualFields">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(periodo)="data">
                <template v-if="data.item.totales">
                  {{ data.item.titulo }}
                </template>
                <template v-if="!data.item.totales">
                  {{ data.item.periodo | periodo }}
                </template>
              </template>
              <template v-slot:cell(montoNeto)="data">
                {{ data.item.montoNeto | moneda }}
              </template>
              <template v-slot:cell(montoNetoSinReembolsos)="data">
                {{ data.item.montoNetoSinReembolsos | moneda }}
              </template>
              <template v-slot:cell(montoNetoReembolsos)="data">
                {{ data.item.montoNetoReembolsos | moneda }}
              </template>
              <template v-slot:cell(opciones)="data">
                <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                  <template slot="button-content">
                    <i class="fa fa-ellipsis-v"></i>
                  </template>
                  <b-dropdown-item @click.stop="exportarPeriodo(data.item)">
                    <i class="fa fa-file-excel-o"></i>Exportar Período</b-dropdown-item>
                  <b-dropdown-item 
                      v-if="consultarCompras"
                      @click.stop="exportarComprasPeriodo(data.item)">
                    <i class="fa fa-file-excel-o"></i>Exportar Compras</b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </b-col>
        </b-row>
    </div>
</template>

<script>

export default {
  data() {
    return {
      ventasTrimestreFields: [
        {key: 'campo'},
        {key: 'valor'},
      ],
      ventasTrimestre1: [],
      ventasTrimestre2: [],
      ventasTrimestre3: [],
      ventasTrimestre4: [],
      ventaMensual: [],
      ventaMensualAnio: 1900,
      ventaMensualBase: [],
      ventaMensualBaseAnio: 1900,

      ventaMensualFields: [],
      ventaMensualBaseFields: [],

      ventaMensualFields: [
        { key: 'periodo'},
        { key: 'montoNeto', class: 'text-right' },
        // { 
        //   key: 'montoNetoSinReembolsos',
        //   label: 'Neto S/Reembolsos',
        //   class: 'text-right' 
        // },
        // { 
        //   key: 'montoNetoReembolsos',
        //   label: 'Neto Reembolsos', 
        //   class: 'text-right' 
        // },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        }
      ],
      
      tableBusy: false,
      tableMensualBusy: false,
      tableMensualBaseBusy: false,

      consultarCompras: false
    }
  },
  created() {
    let userRolId = parseInt(this.$store.getters['user/rolId']);

    switch (userRolId) {
        case 1: /* Superadministrador */ 
        case 2: /* Direccion */
        case 8: /* Calidad */
          this.consultarCompras = true;
    }
  },
  methods: {
    getIndicadores() {
      this.$store.dispatch('resultadosVentas/inicializarVentasTrimestral')
        .then(() => {
          this.getVentasTrimestral();
          this.getVentaMensualBase();
          this.getVentaMensual();
        })
    },
    getFieldsSinReembolsos() {
      return [
        { key: 'periodo'},
        { key: 'montoNeto', class: 'text-right' },
        { 
          key: 'montoNetoSinReembolsos',
          label: 'Neto S/Reembolsos',
          class: 'text-right' 
        },
        { 
          key: 'montoNetoReembolsos',
          label: 'Neto Reembolsos', 
          class: 'text-right' 
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        }
      ]
    },
    getFieldsTotal() {
      return [
        { key: 'periodo'},
        { key: 'montoNeto', class: 'text-right' },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        }
      ]
    },
    getVentasTrimestral() {
        this.tableBusy = true;
        this.$store.dispatch('resultadosVentas/getIndicadorVentasTrimestral')
          .then(() => {
            this.ventasTrimestre1 = this.$store.getters['resultadosVentas/indicadorVentasTrimestre1'];
            this.ventasTrimestre2 = this.$store.getters['resultadosVentas/indicadorVentasTrimestre2'];
            this.ventasTrimestre3 = this.$store.getters['resultadosVentas/indicadorVentasTrimestre3'];
            this.ventasTrimestre4 = this.$store.getters['resultadosVentas/indicadorVentasTrimestre4'];
            
            this.tableBusy = false;
          });
    },
    getVentaMensualBase() {
        this.tableMensualBaseBusy = true;
        this.$store.dispatch('resultadosVentas/getVentaMensualBase')
          .then(() => {
            this.ventaMensualBase = this.$store.getters['resultadosVentas/ventaMensualBase'];
            this.ventaMensualBaseAnio = this.$store.getters['resultadosVentas/ventaMensualBaseAnio'];

            if (parseInt(this.ventaMensualBaseAnio) <= 2023) {
              this.ventaMensualBaseFields = this.getFieldsSinReembolsos();
            } else {
              this.ventaMensualBaseFields = this.getFieldsTotal();
            }

            this.tableMensualBaseBusy = false;
          });
    },
    getVentaMensual() {
        this.tableMensualBusy = true;
        this.$store.dispatch('resultadosVentas/getVentaMensual')
          .then(() => {
            this.ventaMensual = this.$store.getters['resultadosVentas/ventaMensual'];
            this.ventaMensualAnio = this.$store.getters['resultadosVentas/ventaMensualAnio'];

            if (parseInt(this.ventaMensualAnio) <= 2023) {
              this.ventaMensualFields = this.getFieldsSinReembolsos();
            } else {
              this.ventaMensualFields = this.getFieldsTotal();
            }

            this.tableMensualBusy = false;
          });
    },
    exportarPeriodoBase(item) {
      let params = {
        discriminarReembolsos: parseInt(this.ventaMensualBaseAnio) <= 2023,
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta
      }
      this.exportar(params);
    },
    exportarPeriodo(item) {
      let params = {
        discriminarReembolsos: parseInt(this.ventaMensualBaseAnio) <= 2023,
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta
      }
      this.exportar(params);
    },
    exportar(params) {
      this.showSpinner();
      this.$store.dispatch('resultadosVentas/getRptVentaMensual', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let ventas = this.$store.getters['resultadosVentas/resultados'];

          if (ventas) {
            if (ventas.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            /* Agregamos la columna calculada de ventas sin reembolsos */
            ventas = ventas.map(venta => ({
              ...venta,
              montoNetoSinReembolsos: venta.montoNeto - venta.montoNetoReembolsos
            }))

            let title= 'Detalle de Ventas';
            let fileName = 'ventas';
            let format = [
              { titulo: 'Fecha Comprobante', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Fecha Imputacion', nombre: 'fechaImputacionIndicadores', formato: 'fecha' },
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Número', nombre: 'numeroCompleto', formato: '' },
              { titulo: 'Moneda', nombre: 'moneda', formato: '' },
              { titulo: 'Total', nombre: 'total', formato: '' },
              { titulo: 'Cotizacion', nombre: 'cotizacion', formato: '' },
              { titulo: 'Total', nombre: 'montoTotal', formato: '' },
              { titulo: 'Neto Total', nombre: 'montoNeto', formato: '' },
              { titulo: 'Reembolsos + Fee', nombre: 'montoNetoReembolsos', formato: '' },
              { titulo: 'Venta s/Reembolsos + Fee', nombre: 'montoNetoSinReembolsos', formato: '' },
            ];
            // if ((/true/i).test(params.discriminarReembolsos)) {
            //   format.push({ titulo: 'Neto Reembolsos', nombre: 'montoNetoReembolsos', formato: '' });
            // }

            this.exportXLS(title, fileName, ventas, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportarComprasPeriodoBase(item) {
      let params = {
        discriminarReembolsos: parseInt(this.ventaMensualBaseAnio) <= 2023,
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta
      }
      this.exportarCompras(params);
    },
    exportarComprasPeriodo(item) {
      let params = {
        discriminarReembolsos: parseInt(this.ventaMensualBaseAnio) <= 2023,
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta
      }
      this.exportarCompras(params);
    },
    exportarCompras(params) {
      this.showSpinner();
      this.$store.dispatch('resultadosVentas/getComprasByVentaMensual', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let compras = this.$store.getters['resultadosVentas/resultados'];
          console.log(compras);

          if (compras) {
            if (compras.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Compras';
            let fileName = 'compras';
            let format = [
              { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
              { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
              { titulo: 'Fecha', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Moneda', nombre: 'moneda', formato: '' },
              { titulo: 'Total Comprobante Moneda Original', nombre: 'totalComprobante', formato: '' },
              { titulo: 'Total Comprobante Pesos', nombre: 'totalComprobantePesos', formato: '' },
              { titulo: 'Neto Comprobante', nombre: 'montoNetoComprobante', formato: '' },
              { titulo: 'Neto Ordenes Proveedores', nombre: 'montoNetoOrdenesProveedores', formato: '' },
              { titulo: 'Neto Remitos', nombre: 'montoNetoRemitos', formato: '' },
              { titulo: 'Neto Viáticos', nombre: 'montoNetoViaticos', formato: '' },
              { titulo: 'Amortización - Años', nombre: 'amortizacionAnios', formato: '' },
            ];

            this.exportXLS(title, fileName, compras, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    }

  }
}
</script>

<style>
  .dashboard-ventas-trimestral {
    margin-bottom: 30px;
  }
  .dashboard-ventas-trimestral table thead {
    display: none;
  }
  .dashboard-ventas-trimestral table tbody tr:first-child td {
    border-top: none;
  }
  .dashboard-ventas-trimestral table tbody tr:first-child td {
    font-weight: 700;
    display: table-cell;
    width: 100%;
  }
  .dashboard-ventas-trimestral table tbody tr:first-child td:nth-child(1) {
    overflow: visible;
    white-space: nowrap;
  }
  .dashboard-ventas-trimestral table tbody tr:first-child td:nth-child(2) {
    display: none;
  }
  .dashboard-ventas-trimestral table tbody tr td:nth-child(2) {
    text-align: right;
  }

  .dashboard-venta-mensual div:nth-child(1) .registro {
    /* padding-left: 30px; */
    padding-right: 30px;
  }
  .dashboard-venta-mensual div:nth-child(2) .registro {
    padding-left: 30px;
    /* padding-right: 30px; */
  }

  .dashboard-venta-mensual table thead tr th {
    border-top: none;
  }

  .dashboard-venta-mensual table tr.table-totales {
    font-weight: 700;
  }

  .dashboard-venta-mensual .registro table td[aria-colindex="1"] {
    width: 20%;
  }
  .dashboard-venta-mensual .registro table td[aria-colindex="2"] {
    width: calc(80% - 30px);
  }
  .dashboard-venta-mensual .registro table td[aria-colindex="3"] {
    width: 30px;
  }

  .dashboard-venta-mensual .registro.reembolsos table td[aria-colindex="1"] {
    width: 10%;
  }
  .dashboard-venta-mensual .registro.reembolsos table td[aria-colindex="2"],
  .dashboard-venta-mensual .registro.reembolsos table td[aria-colindex="3"],
  .dashboard-venta-mensual .registro.reembolsos table td[aria-colindex="4"] {
    width: calc(30% - 10px);
  }
  .dashboard-venta-mensual .registro.reembolsos table td[aria-colindex="5"] {
    width: 30px;
  }
</style>


